module.exports = __webpack_public_path__ + "images/emoji/arrow_upper_left.de806385c888fd65dfab.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/arrow_upper_left.png
// module id = ebYz
// module chunks = 2